module.exports = __webpack_public_path__ + "static/media/paypal-logo-png-transparent.53ad69fe.png";